document.addEventListener('DOMContentLoaded', function () {

  // *.*.*.*.*.*.*.*.*.*.* theme color *.*.*.*.*.*.*.*.*.*.*
  const darkBtn = document.querySelector('.theme-switcher-dark');
  const lightBtn = document.querySelector('.theme-switcher-light');

  function applyTheme(theme) {
    const root = document.documentElement;
    if (theme === 'dark') {
      root.classList.add('dark');
      localStorage.setItem('theme', 'dark');
    } else {
      root.classList.remove('dark');
      localStorage.setItem('theme', 'light');
    }
  }

  function loadTheme() {
    const savedTheme = localStorage.getItem('theme');
    if (savedTheme) {
      applyTheme(savedTheme);
    } else {
      const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
      applyTheme(prefersDark ? 'dark' : 'light');
    }
  }

  darkBtn.addEventListener('click', () => applyTheme('dark'));
  lightBtn.addEventListener('click', () => applyTheme('light'));

  window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', e => {
    if (!localStorage.getItem('theme')) {
      applyTheme(e.matches ? 'dark' : 'light');
    }
  });

  window.addEventListener('DOMContentLoaded', loadTheme);
  // *.*.*.*.*.*.*.*.*.*.* theme color *.*.*.*.*.*.*.*.*.*.*

  if (window.screen.width < 500) {
    // *.*.*.*.*.*.*.*.*.*.* START OF MAIN MENU *.*.*.*.*.*.*.*.*.*.*
    const mainMenu = document.querySelector("#top_nav");
    const openButton = document.querySelector("#mobile_menu");
    const closeButton = document.querySelector("#close_menu");
    if (mainMenu && openButton && closeButton) {
      if (window.innerWidth < 1024) {
        function openMenu() {
          mainMenu.classList.remove("hidden");
          requestAnimationFrame(() => {
            mainMenu.classList.remove("translate-x-full");
            mainMenu.classList.add("translate-x-0");
          });
        }

        function closeMenu() {
          mainMenu.classList.add("translate-x-full");
          mainMenu.addEventListener(
            "transitionend",
            () => {
              if (mainMenu.classList.contains("translate-x-full")) {
                mainMenu.classList.add("hidden");
              }
            },
            { once: true }
          );
        }

        if (openButton && mainMenu) {
          openButton.addEventListener("click", openMenu);
        }
        if (closeButton && mainMenu) {
          closeButton.addEventListener("click", closeMenu);
        }

        // ----- SUB_MENU -----
        document.querySelectorAll('.submenu_icon').forEach(subMenuButton => {
          subMenuButton.addEventListener('click', () => {
            const subMenu = subMenuButton.parentNode.nextElementSibling;
            if (subMenu) {
              if (subMenu.classList.contains('hidden')) {
                subMenu.classList.remove('hidden');
                setTimeout(() => {
                  subMenu.classList.add('transition-all', 'duration-300');
                  subMenu.classList.remove('opacity-0');
                  subMenu.classList.add('opacity-100');
                  subMenuButton.classList.add('rotate-180');
                }, 10);
              } else {
                subMenu.classList.add('opacity-0');
                subMenu.classList.remove('opacity-100');
                subMenu.classList.add('transition-all', 'duration-300');
                subMenuButton.classList.remove('rotate-180');
                setTimeout(() => {
                  subMenu.classList.add('hidden');
                }, 300);
              }
            }
          });
        });
        // ----- END OF SUB_MENU -----
      }
    }
    // *.*.*.*.*.*.*.*.*.*.* END OF MAIN MENU *.*.*.*.*.*.*.*.*.*.*
  }

  if (window.innerWidth > 500) {
    // ---- NEWS PROGRESS CIRCLE ----
    if(document.getElementById("progressCircle")) {
      const circle = document.getElementById("progressCircle");
      const radius = 45;
      const circumference = 2 * Math.PI * radius;

      circle.style.strokeDasharray = circumference;
      circle.style.strokeDashoffset = circumference;

      const target = document.querySelector(".side_fixed");
      let placeholder = null;

      function updateProgress() {
        if (!target) return;

        const scrollTop = window.scrollY;
        const rect = target.getBoundingClientRect();
        const parent = target.parentNode;
        const parentTop = parent.offsetTop;
        const parentBottom = parentTop + parent.offsetHeight;
        const targetHeight = target.offsetHeight;

        // --- progress circle ---
        const docHeight = document.documentElement.scrollHeight - window.innerHeight;
        const scrollPercent = scrollTop / docHeight;
        circle.style.strokeDashoffset = circumference - scrollPercent * circumference;

        if (!placeholder) {
          placeholder = document.createElement("div");
          placeholder.style.width = target.offsetWidth + "px";
          placeholder.style.height = targetHeight + "px";
        }

        // --- MODES ---
        if (scrollTop < parentTop) {
          target.style.position = "";
          target.style.top = "";
          target.style.left = "";
          target.style.width = "";
          target.style.zIndex = "";
          if (placeholder.parentNode) placeholder.remove();
        } else if (scrollTop >= parentTop && scrollTop < parentBottom - targetHeight) {
          // fixed
          if (!placeholder.parentNode) parent.insertBefore(placeholder, target);
          target.style.position = "fixed";
          target.style.top = "0px";
          target.style.left = rect.left + "px";
          target.style.width = rect.width + "px";
          target.style.zIndex = "100";
        } else {
          // end_fixed
          if (!placeholder.parentNode) parent.insertBefore(placeholder, target);
          target.style.position = "absolute";
          target.style.top = parent.offsetHeight - targetHeight + "px";
          target.style.left = "";
          target.style.width = rect.width + "px";
          target.style.zIndex = "100";
        }
      }

      window.addEventListener("scroll", updateProgress);
      window.addEventListener("resize", updateProgress);
      updateProgress();

      window.addEventListener('beforeprint', () => {
        if (!target) return;
        target.style.position = '';
        target.style.top = '';
        target.style.left = '';
        target.style.width = '';
        target.style.zIndex = '';
        if (placeholder?.parentNode) placeholder.remove();
      });
      window.addEventListener('afterprint', () => {
        updateProgress();
      });
    }
    // ---- END OF NEWS PROGRESS CIRCLE ----
  }

  // (header ticker and breaking news: same code as main.js — news pages load only this bundle)
  // *.*.*.*.*.*.*.*.*.*.* HEADER NEWS TICKER (seamless loop) *.*.*.*.*.*.*.*.*.*.*
  // clone the items until the list is one track wider than the originals, then
  // slide exactly one originals-width so the loop restarts without a jump
  const tickerLists = document.querySelectorAll('.news_ticker .ticker-list');
  if (tickerLists.length) {
    // width of the original items only (fractional: a rounded offset makes every loop tick)
    function tickerOriginalsWidth(list) {
      const count = Number(list.dataset.tickerCount) || list.children.length;
      let width = 0;
      for (let i = 0; i < count && i < list.children.length; i++) {
        width += list.children[i].getBoundingClientRect().width;
      }
      return width;
    }

    function setupTickerList(list) {
      const track = list.closest('.ticker-track');

      if (!list.dataset.tickerOriginal) {
        list.dataset.tickerOriginal = list.innerHTML;
      }
      list.classList.remove('is-running');
      list.innerHTML = list.dataset.tickerOriginal;

      const originals = Array.from(list.children);
      list.dataset.tickerCount = originals.length;
      const originalWidth = tickerOriginalsWidth(list);
      const trackWidth = track ? track.getBoundingClientRect().width : 0;
      if (!originalWidth) return;

      while (list.getBoundingClientRect().width < originalWidth + trackWidth) {
        originals.forEach((item) => {
          const clone = item.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          clone.querySelectorAll('a').forEach((a) => a.setAttribute('tabindex', '-1'));
          list.appendChild(clone);
        });
      }

      list.dataset.tickerWidth = originalWidth;
      list.style.setProperty('--ticker-offset', '-' + originalWidth.toFixed(3) + 'px');
      // speed: ~70px per second (min 12s for a short list)
      list.style.setProperty('--ticker-duration', Math.max(12, originalWidth / 70).toFixed(3) + 's');

      // start (or restart) the animation from its first frame
      void list.offsetWidth;
      list.classList.add('is-running');
    }

    tickerLists.forEach(setupTickerList);

    // the web font can arrive after the first measurement and widen the titles:
    // re-measure once it is ready, and rebuild only if the width really changed
    if (document.fonts && document.fonts.status !== 'loaded') {
      document.fonts.ready.then(() => {
        tickerLists.forEach((list) => {
          if (Math.abs(tickerOriginalsWidth(list) - Number(list.dataset.tickerWidth || 0)) > 0.5) {
            setupTickerList(list);
          }
        });
      });
    }

    let tickerResizeWidth = window.innerWidth;
    window.addEventListener('resize', () => {
      // mobile browsers fire resize on scroll (toolbar show/hide); only rebuild on width changes
      if (window.innerWidth === tickerResizeWidth) return;
      tickerResizeWidth = window.innerWidth;
      tickerLists.forEach(setupTickerList);
    }, { passive: true });
  }
  // *.*.*.*.*.*.*.*.*.*.* END OF HEADER NEWS TICKER *.*.*.*.*.*.*.*.*.*.*

  // *.*.*.*.*.*.*.*.*.*.* BREAKING NEWS (FRONT_Q, fixed bottom bar) *.*.*.*.*.*.*.*.*.*.*
  const breakingBar = document.getElementById('breaking_news');
  if (breakingBar && !breakingBar.hidden) {
    const breakingItems = Array.from(breakingBar.querySelectorAll('[data-breaking-item]'));
    const breakingScrollBtn = document.getElementById('scrollTopBtn');

    // keep page content and the scroll-to-top button clear of the bar
    const reserveBreakingSpace = () => {
      const h = breakingBar.hidden ? 0 : breakingBar.offsetHeight;
      document.body.style.paddingBottom = h ? h + 'px' : '';
      if (breakingScrollBtn) {
        breakingScrollBtn.style.bottom = h ? (h + 16) + 'px' : '';
      }
    };
    reserveBreakingSpace();
    window.addEventListener('resize', reserveBreakingSpace, { passive: true });

    // rotate items one at a time (pauses while hovered or focused)
    if (breakingItems.length > 1 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      let breakingIndex = 0;
      let breakingPaused = false;
      breakingBar.addEventListener('mouseenter', () => { breakingPaused = true; });
      breakingBar.addEventListener('mouseleave', () => { breakingPaused = false; });
      breakingBar.addEventListener('focusin', () => { breakingPaused = true; });
      breakingBar.addEventListener('focusout', () => { breakingPaused = false; });
      setInterval(() => {
        if (breakingPaused || breakingBar.hidden) return;
        breakingItems[breakingIndex].classList.replace('opacity-100', 'opacity-0');
        breakingItems[breakingIndex].classList.add('invisible');
        breakingIndex = (breakingIndex + 1) % breakingItems.length;
        breakingItems[breakingIndex].classList.remove('invisible');
        breakingItems[breakingIndex].classList.replace('opacity-0', 'opacity-100');
      }, 5000);
    }

    // close: slide down, then remember this set of items for the rest of the session
    const breakingClose = breakingBar.querySelector('[data-breaking-close]');
    if (breakingClose) {
      breakingClose.addEventListener('click', () => {
        try { sessionStorage.setItem('breakingDismissed', breakingBar.dataset.breakingKey); } catch (e) {}
        breakingBar.dataset.closed = '';
        setTimeout(() => {
          breakingBar.hidden = true;
          reserveBreakingSpace();
        }, 500);
      });
    }
  }
  // *.*.*.*.*.*.*.*.*.*.* END OF BREAKING NEWS *.*.*.*.*.*.*.*.*.*.*

  // ---- NEWS COUNT WORDS ----
  if(document.getElementById('ck_editor')) {
    const news = document.getElementById('ck_editor').innerText;
    // Count characters (without spaces)
    const charCount = news.replace(/\s+/g, '').length;
    // Reading speed: assume ~0.3 sec per character
    const timePerChar = 0.3;
    const totalSeconds = Math.ceil(charCount * timePerChar);
    // Calculate minutes only
    const minutes = Math.ceil(totalSeconds / 60);
    // Display in the center of the circle
    // document.getElementById('readingTime').innerText = `${minutes} دقیقه`;
    if (document.getElementById('readingMinutes')) {
      // Persian digits on the fa site
      document.getElementById('readingMinutes').innerText = document.documentElement.lang === 'fa' ? minutes.toLocaleString('fa-IR') : minutes;
    }
    }
  // ---- END OF NEWS COUNT WORDS ----

  // *.*.*.*.*.*.*.*.*.*.* OPEN SEARCH *.*.*.*.*.*.*.*.*.*.*
  const open = document.querySelector('.search_open');
  const box = document.querySelector('#search_box');
  const close = document.querySelector('.search_close');
  open.addEventListener('click', () => {
    setTimeout(() => {
      box.classList.toggle('hidden');
      box.classList.toggle('block');
    }, 10);
  });  
  close.addEventListener('click', () => {
    setTimeout(() => {
      box.classList.toggle('hidden');
    }, 10);
  });
  // *.*.*.*.*.*.*.*.*.*.* OPEN SEARCH *.*.*.*.*.*.*.*.*.*.*

  // *.*.*.*.*.*.*.*.*.*.* START OF light Gallery *.*.*.*.*.*.*.*.*.*.*
  if (document.querySelectorAll('#album_list')) {
    var gallery = document.querySelectorAll("#album_list");
    gallery.forEach(function (pic) {
      lightGallery(pic, {
        speed: 500,
        plugins: [lgThumbnail],
        thumbnail: true

      });
    });
  }
  // *.*.*.*.*.*.*.*.*.*.* END OF light Gallery *.*.*.*.*.*.*.*.*.*.*

  // *.*.*.*.*.*.*.*.*.*.* RESPONSIVE TABLE *.*.*.*.*.*.*.*.*.*.*
  if (document.querySelector(".ck_editor")) {
    var tables = document.querySelectorAll(".ck_editor table");
    tables.forEach(function (table) {
      var parentTable = document.createElement('div');
      parentTable.classList.add("table_res");
      table.parentNode.replaceChild(parentTable, table);
      parentTable.appendChild(table);
    });
  }
  // *.*.*.*.*.*.*.*.*.*.* END OF RESPONSIVE TABLE *.*.*.*.*.*.*.*.*.*.*

  // --- SPLIDE ELEMENT ---
  if (document.getElementById('news_slide')) {
    new Splide('#news_slide', {
      type: 'loop',
      perPage: 1,
      pagination: true,
      gap: '1em',
      focus: 'center',
      autoplay: true,
      interval: 3000,
      whell: true,
      flickMaxPages: 1,
      updateOnMove: true,
      direction: document.documentElement.dir === 'rtl' ? 'rtl' : 'ltr',
      arrows: true,
    }).mount();
  }
  // --- SPLIDE ELEMENT ---

  // --- SHORTLINK ---
  var link = document.querySelector(".short_link");
  var msg  = document.querySelector(".tinyurl_copied");

  if (link && msg) {
    link.addEventListener("click", function (event) {
      event.preventDefault();
      navigator.clipboard.writeText(link.href);
      msg.classList.replace("hidden", "block");
      setTimeout(function () {
        msg.classList.replace("block", "hidden");
      }, 1500);
    });
  }
  // --- END SHORTLINK ---


  // ---- START OF COMMENT NEWS AJAX ----
  if (document.getElementById('comment_list_ajax')) {
    const commentList = document.getElementById('comment_list_ajax');
    const loadMoreBtn = document.getElementById('load_more_comment');
    let currentPage = 1;
    // Initialize limit comment number
    const limitPage = 5;
    if (news_comment < limitPage) loadMoreBtn.remove();
    const loadMoreComments = () => {
      fetch(`/comments/ajaxCommentList?newsId=${news_id}&page=${currentPage}&limit=${limitPage}`)
        .then(response => response.json())
        .then(data => {
          if (!data || data.length < limitPage) loadMoreBtn.style.display = 'none';
          if (data) {
            data.forEach(comment => {
              const renderChildren = children => children ? `
              <ul>${children.map(child => `
              <li class="border border-[#dfdfe6] shadow-md shadow-[#7171fb33] rounded-xl p-6 mt-4 dark:border-[#2e2e2e]">
                <div class="flex justify-between py-2 border-b border-[#e1e1e8] dark:border-[#2e2e2e]">
                  <div class="font-bold text-md text-[#5753cc]">
                    ${child.name || window.i18n.commentUnknown}
                  </div>
                  <div class="flex justify-between gap-6">
                    <span class="text-gray-600 py-2 dark:text-white">
                      <time datetime="${child.creation}">${child.date}</time>
                    </span>
                    <button class="flex items-center gap-2" aria-label="like" onclick="Rate.plus(${child.master_id})">
                      <span id="rateplus${child.master_id}">${child.plus || 0}</span>
                      <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                      <path fill="#134f1a" d="M4 21h1V8H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2M20 8h-7l1.122-3.368A2 2 0 0 0 12.225 2H12L7 7.438V21h11l3.912-8.596L22 12v-2a2 2 0 0 0-2-2"/>
                      </svg>
                    </button>
                    <button class="flex items-center gap-2" aria-label="dislike" onclick="Rate.minus(${child.master_id})">
                      <span id="rateminus${child.master_id}">${child.minus || 0}</span>
                      <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                      <path fill="#7b0808" d="M20 3h-1v13h1a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2M4 16h7l-1.122 3.368A2 2 0 0 0 11.775 22H12l5-5.438V3H6l-3.937 8.649l-.063.293V14a2 2 0 0 0 2 2"/>
                      </svg>
                    </button>
                    <button  aria-label="replay" onclick="setCommentParentId(${child.id})">${window.i18n.commentReply}</button>
                  </div>
                </div>
                <div class="text-gray-600 py-2 dark:text-white">
                  <p class="break-all">${child.message}</p>
                </div>
              </li>`).join('')}
              </ul>` : '';

              commentList.innerHTML += `
              <li class="bg-white rounded-2xl border border-[#dfdfe6] shadow-md shadow-[0_5px_25px_0_rgba(113,113,251,0.2)] px-4 py-2 my-4 dark:border-[#2e2e2e] dark:bg-[#222] dark:shadow-none">
                <div class="flex justify-between py-2 border-b border-[#e1e1e8] dark:border-[#2e2e2e]">
                  <div class="font-bold text-md text-[#5753cc]">
                    ${comment.name || window.i18n.commentUnknown}
                  </div>
                  <div class="flex justify-between gap-6">
                    <span class="text-gray-600 py-2 dark:text-white">
                      <time datetime="${comment.creation}">${comment.date}</time>
                    </span>
                    <button class="flex items-center gap-2" aria-label="like" onclick="Rate.plus(${comment.master_id})">
                      <span id="rateplus${comment.master_id}">${comment.plus || 0}</span>
                      <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                      <path fill="#134f1a" d="M4 21h1V8H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2M20 8h-7l1.122-3.368A2 2 0 0 0 12.225 2H12L7 7.438V21h11l3.912-8.596L22 12v-2a2 2 0 0 0-2-2"/>
                      </svg>
                    </button>
                    <button class="flex items-center gap-2" aria-label="dislike" onclick="Rate.minus(${comment.master_id})">
                      <span id="rateminus${comment.master_id}">${comment.minus || 0}</span>
                      <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                      <path fill="#7b0808" d="M20 3h-1v13h1a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2M4 16h7l-1.122 3.368A2 2 0 0 0 11.775 22H12l5-5.438V3H6l-3.937 8.649l-.063.293V14a2 2 0 0 0 2 2"/>
                      </svg>
                    </button>
                    <button aria-label="replay" onclick="setCommentParentId(${comment.id})">${window.i18n.commentReply}</button>
                  </div>
                </div>
                <div class="text-gray-600 py-2 dark:text-white">
                  <p class="break-all">${comment.message}</p>
                  ${comment.children === null || comment.children.length === 0 ? '' : renderChildren(comment.children)}
                </div>
              </li>`;
            });
            currentPage++;
          }
        })
        .catch(error => console.error(error));
    };

    loadMoreComments();
    loadMoreBtn.addEventListener('click', loadMoreComments);
  }
  // ---- END OF COMMENT NEWS AJAX ----

  // ---- PAGES SCROLL TO TOP ----
  if(document.getElementById('scrollTopBtn')) {
    const progressCircle = document.getElementById('scrollProgress');
    const scrollButton = document.getElementById('scrollTopBtn');
    const progressRadius = 27;
    const progressCircumference = 2 * Math.PI * progressRadius;

    progressCircle.style.strokeDasharray = progressCircumference;
    progressCircle.style.strokeDashoffset = progressCircumference;

    // Update progress circle and toggle visibility on scroll
    const updateScrollProgress = () => {
      const scrollPosition = window.scrollY;
      const documentHeight = document.documentElement.scrollHeight - window.innerHeight;
      // Show button after scrolling 50px
      if (scrollPosition > 50) {
        scrollButton.classList.remove('hidden');
      } else {
        scrollButton.classList.add('hidden');
      }
      // Update circle stroke offset
      const offset = progressCircumference - (scrollPosition / documentHeight) * progressCircumference;
      progressCircle.style.strokeDashoffset = offset;
    }

    window.addEventListener('scroll', updateScrollProgress);
    // Scroll smoothly to top on click
    scrollButton.addEventListener('click', () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }
  // ---- END OF PAGES SCROLL TO TOP ----

})
